import React from "react";
import SaveIcon from "@material-ui/icons/SaveAlt";
import DoneAll from "@material-ui/icons/DoneAll";
import DeleteIcon from "@material-ui/icons/DeleteOutlined";
import Clear from "@material-ui/icons/Clear";
import {
  IndexViewComponent,
  PopupMessage,
  SecuredListButton
} from "lego-gui-lib/lib";
import { GetApp } from "@material-ui/icons";
import { inject } from "mobx-react";
import { capitalize } from "@material-ui/core/utils";
import { mainStore } from "../../core/mainStore";

export const toolbarButtonsWithExports = (
  showLoaderHandler: Function,
  hideLoaderHandler: Function
) => (indexProps: IndexViewComponent<any, any>) => (close: () => void) => {
  const arr = [];
  const commons = mainStore.commons;

  const exportSelected = async () => {
    showLoaderHandler();
    const resp = await indexProps.props.dataSource.exportSelected(
      "text/csv",
      indexProps.props.dataSource.selected
    );
    close();
    hideLoaderHandler();
  };

  const exportAll = async () => {
    showLoaderHandler();
    const resp = await indexProps.props.dataSource.exportAll(
      "text/csv",
      indexProps.prepareParams()
    );
    close();
    hideLoaderHandler();
  };

  const Button = inject("i18n")(
    ({ i18n: i18n, title: titleArgs, ...props }) => {
      const title = capitalize(i18n.t(...titleArgs));
      return <SecuredListButton title={title} {...props} />;
    }
  );

  arr.push(
    <Button
      title={["lego:views.index.row.exportAll", "Export All"]}
      callbackFunction={exportAll}
      key={"exportAll"}
    >
      <GetApp />
    </Button>
  );

  arr.push(
    <Button
      title={["lego:views.index.row.export", "Export"]}
      callbackFunction={exportSelected}
      key={"export"}
      disabled={indexProps.props.dataSource.selected.length === 0}
    >
      <SaveIcon />
    </Button>
  );

  return arr;
};
